import React from 'react';

export function HelpCenter() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Help Center</h1>
      <p className="text-gray-600">Help Center content coming soon...</p>
    </div>
  );
}